const initialstate = {
    data:[],
    checkdata:[],
  }
  
  const DonationsReducers =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'fetch_check_data_success':
            return {... state, checkdata:action.payload};
                       default :
            return state;
    }
  };
  export default DonationsReducers;